import store from "../store";
import jwt_decode from "jwt-decode";

export default function auth({ next, router }) {
    if (!store.getters.loggedIn) {
        return router.push({ name: 'Login' }).catch(()=> {});
    }

    const token = localStorage.getItem('token')

    if (token) {
        const access_token = jwt_decode(token)

        if (access_token.user != 'vendor_robot' || access_token.user == '') {
            store.commit('removeStorage')
            return router.push({ name: 'Login' }).catch(()=> {});
        }
    }

    return next();
}